import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useParticipantAccess } from "./participantAccess";

/**
 * Legacy route redirect — Communicate opens as a large modal on the
 * Feasibility list (template select + send).
 */
const CommunicationWizard = () => {
  const [searchParams] = useSearchParams();
  const { canViewFeasibility, loading: accessLoading } = useParticipantAccess();
  const participantId = String(searchParams.get("participantId") || "").trim();

  if (accessLoading) {
    return <div className="participant-manager-page pm-page--bootstrapping" />;
  }
  if (!canViewFeasibility) {
    return <Navigate to="/notification-center" replace />;
  }

  return (
    <Navigate
      to="/participantmanager/feasibility"
      replace
      state={
        participantId
          ? { openCommunicateFeasibilityId: participantId }
          : {}
      }
    />
  );
};

export default CommunicationWizard;
